import video from './assets/video.mp4';
import video2 from './assets/video2.mp4';

const approachSlides = [
  {
    title: 'Internal allocations',
    descr:
      'Our internal portfolio brings together <span>various algorithmic models</span> into a single robust trading mechanism. We harness insights from unconventional data streams like <span>blockchain and news, as well as price-based models</span>, equipping it with a comprehensive understanding of the market. Our infrastructure allows us to <span>trade with different frequencies</span> from milliseconds to days and across different markets: spot, futures, options.',
    videoSrc: video,
    to: 'careers',
  },
  {
    title: 'External allocations',
    descr:
      'Our external portfolio has a strict evaluation criteria process to ensure <span>we only collaborate with the best in the field.</span> We leverage our industry knowledge and proprietary technology to rigorously <span>assess all investment approaches.</span> In our relentless pursuit of excellence, we continually <span>explore</span> opportunities with new managers and <span>stay ahead of industry trends.</span>',
    videoSrc: video2,
    to: 'asset-managers',
  },
];

export default approachSlides;
